var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "flex items-start gap-20 mb-3 pt-4" }, [
      _c("div", { staticClass: "flex w-2/5 flex-col items-center px-3" }, [
        _c("div", { staticClass: "flex-1 flex flex-col md:flex-row pb-4" }, [
          _c("div", { staticClass: "w-full flex-1 mx-2" }, [
            _c("div", { staticClass: "my-2 p-1 flex" }, [
              _c("img", { attrs: { src: _vm.album.cover, width: "200px" } })
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "flex w-full py-4" }, [
        _c(
          "div",
          { staticClass: "w-1/2" },
          [
            _c("form-item", {
              attrs: { label: "Album Name" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function() {
                    return [
                      _c("p", { staticClass: "text-left font-bold" }, [
                        _vm._v(_vm._s(_vm.album.name))
                      ])
                    ]
                  },
                  proxy: true
                }
              ])
            }),
            _vm._v(" "),
            _c("form-item", {
              attrs: { label: "Artist Name" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function() {
                    return [
                      _c("p", { staticClass: "text-left font-bold" }, [
                        _vm._v(_vm._s(_vm.album.artist))
                      ])
                    ]
                  },
                  proxy: true
                }
              ])
            }),
            _vm._v(" "),
            _c("form-item", {
              attrs: { label: "Year" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function() {
                    return [
                      _c("p", { staticClass: "text-left font-bold" }, [
                        _vm._v(_vm._s(_vm.album.year))
                      ])
                    ]
                  },
                  proxy: true
                }
              ])
            }),
            _vm._v(" "),
            _c("form-item", {
              attrs: { label: "Language" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function() {
                    return [
                      _c("p", { staticClass: "text-left font-bold" }, [
                        _vm._v(_vm._s(_vm.album.language))
                      ])
                    ]
                  },
                  proxy: true
                }
              ])
            }),
            _vm._v(" "),
            _c("form-item", {
              attrs: { label: "Composer" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function() {
                    return [
                      _c("p", { staticClass: "text-left font-bold" }, [
                        _vm._v(_vm._s(_vm.album.composer || "-"))
                      ])
                    ]
                  },
                  proxy: true
                }
              ])
            })
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "w-1/2" },
          [
            _c("form-item", {
              attrs: { label: "Subscription" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function() {
                    return [
                      _c("p", { staticClass: "text-left font-bold" }, [
                        _vm._v(
                          _vm._s(_vm.album.is_subscription == 0 ? "No" : "Yes")
                        )
                      ])
                    ]
                  },
                  proxy: true
                }
              ])
            }),
            _vm._v(" "),
            _c("form-item", {
              attrs: { label: "Sell Song Individually" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function() {
                    return [
                      _c("p", { staticClass: "text-left font-bold" }, [
                        _vm._v(
                          _vm._s(
                            _vm.album.sell_song_individually == 0 ? "No" : "Yes"
                          )
                        )
                      ])
                    ]
                  },
                  proxy: true
                }
              ])
            }),
            _vm._v(" "),
            _c("form-item", {
              attrs: { label: "Paid Album" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function() {
                    return [
                      _c("p", { staticClass: "text-left font-bold" }, [
                        _vm._v(_vm._s(_vm.album.is_paid == 0 ? "Free" : "Paid"))
                      ])
                    ]
                  },
                  proxy: true
                }
              ])
            }),
            _vm._v(" "),
            _vm.album.is_paid == 1
              ? _c("form-item", {
                  attrs: { label: "Album Price (USD)" },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "default",
                        fn: function() {
                          return [
                            _c("p", { staticClass: "text-left font-bold" }, [
                              _vm._v(
                                "$ " +
                                  _vm._s(
                                    parseFloat(
                                      _vm.toDollar(_vm.album.price)
                                    ).toFixed(2)
                                  ) +
                                  "    = " +
                                  _vm._s(
                                    parseFloat(_vm.album.price).toFixed(2)
                                  ) +
                                  " Credits"
                              )
                            ])
                          ]
                        },
                        proxy: true
                      }
                    ],
                    null,
                    false,
                    3521361570
                  )
                })
              : _vm._e(),
            _vm._v(" "),
            _c("form-item", {
              attrs: { label: "Copyright" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function() {
                    return [
                      !!_vm.album.copyright
                        ? _c(
                            "a",
                            {
                              staticClass:
                                "underline w-full inline-block text-left font-bold",
                              attrs: {
                                href: _vm.album.copyright,
                                target: "_blank"
                              }
                            },
                            [_vm._v("Copyright Link")]
                          )
                        : _c("p", { staticClass: "text-left font-bold" }, [
                            _vm._v("-")
                          ])
                    ]
                  },
                  proxy: true
                }
              ])
            })
          ],
          1
        )
      ])
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "px-2" },
      [
        _c(
          "data-tables",
          {
            attrs: {
              layout: "table",
              data: _vm.dataDetailSong,
              total: _vm.dataDetailSong.length,
              "pagination-props": { pageSizes: [100] }
            }
          },
          [
            _vm._l(_vm.titleSong, function(title) {
              return _c("el-table-column", {
                key: title.prop,
                attrs: {
                  prop: title.prop,
                  label: title.label,
                  sortable: "custom"
                }
              })
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: { label: "Song", width: "250px" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function(scope) {
                    return [
                      _c(
                        "audio",
                        {
                          staticClass: "audio-player",
                          staticStyle: { width: "240px" },
                          attrs: {
                            controls: "",
                            src: scope.row.file,
                            id: "audioPlayer" + scope.row.id,
                            controlsList: "nodownload",
                            type: "audio/mp3",
                            preload: "none"
                          }
                        },
                        [
                          _vm._v(
                            "\n            Audio tag not supported\n          "
                          )
                        ]
                      )
                    ]
                  }
                }
              ])
            })
          ],
          2
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-bdc601d8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bdc601d8","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Album/DetailAlbum.vue
// module id = null
// module chunks = 